import { object } from "prop-types";

export const getFreePositions = (objects) => {
  const positions = ['center', 'top', 'bottom'];
  return objects.length
    ? positions.filter(
      (position) => !objects.find(object => object.userData.position === position)
    ) : positions;
}

export const rescaleObject = (selectedObject, canvasSize, fit = false) => {
  let boundSize = selectedObject.getBoundSize();
  const heightFactor = selectedObject.userData.position === 'center' ? 1 : 0.5;
  const maxHeight = heightFactor * canvasSize.height;
  if (boundSize.height > maxHeight || fit) {
    selectedObject.scaling *= maxHeight / boundSize.height;
  }
  boundSize = selectedObject.getBoundSize();
  if (boundSize.width > canvasSize.width) {
    selectedObject.scaling *= canvasSize.width / boundSize.width;
  }
}

export const alignObjectToArea = (selectedObject, canvasSize) => {
  const currentArea = selectedObject.userData.position;
  if (currentArea === 'top') {
    selectedObject.y = canvasSize.height * 0.25;

  } else if (currentArea === 'bottom') {
    selectedObject.y = canvasSize.height * 0.75;
  } else {
    selectedObject.y = canvasSize.height * 0.5;
  }
  selectedObject.x = canvasSize.width * 0.5;
}

export const setObjectPosition = (selectedObject, position, objects, canvasSize) => {
  const objectToSwap = objects && objects.find(o => o !== selectedObject && o.userData.position === position);
  if (objectToSwap) {
    objectToSwap.userData.position = selectedObject.userData.position;
    rescaleObject(objectToSwap, canvasSize);
    alignObjectToArea(objectToSwap, canvasSize);
  }
  selectedObject.userData.position = position;
}
